import { RequestTypes as REQUEST_TYPES } from '../../../constants/enums';

/**
 * Determines whether request includes multiple users.
 *
 * @function
 * @param {string} requestType request type defined in query parameter.
 * @returns indication whether request includes multiple users.
 */
export const isMultiUserRequest = requestType =>
	requestType === REQUEST_TYPES.MULTI_USER ||
	requestType === REQUEST_TYPES.MULTI_SERVICE_ACCOUNT ||
	requestType === REQUEST_TYPES.MULTI_USER_NON_EMPLOYEE;
